import "./styles.scss";

import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

import Button from "components/Button";
import FormikTextarea from "components/formik/FormikTextarea";

const mainClass = "new-project-content__summary";

const SummaryProject = () => {
  const { t } = useTranslation();
  const { values, isSubmitting } = useFormikContext();

  return (
    <div className={mainClass}>
      <h3>{t("Describe what you need")}</h3>
      <div className={`${mainClass}__row`}>
        <div className={`${mainClass}__column`}>
          <FormikTextarea
            name="message"
            placeholder={t(
              "Provide as many details as possible about the projects you would like to implement with us"
            )}
          />
        </div>
        <div className={`${mainClass}__column`}>
          <Button
            type="submit"
            loading={isSubmitting}
            disabled={!(values?.options?.length > 0)}
          >
            {t("Send message")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SummaryProject;
